import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, permission }) {
  const { user, loading, hasPermission } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-muted-foreground font-display">جاري التحميل...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (permission && !hasPermission(permission)) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-center max-w-md">
          <div className="text-2xl font-display font-bold text-destructive mb-2">
            غير مصرح
          </div>
          <p className="text-muted-foreground">
            ليس لديك صلاحية للوصول لهذه الصفحة
          </p>
        </div>
      </div>
    );
  }
  return children;
}
